export function deepchecker(potential){
  let failed="Still not the flag";
  let bytes = [];
  for(let i=0; i < potential.length; i++){
    bytes.push(potential.charCodeAt(i)); 
  }
  let crazy=[76, 37, 75, 33, 64, 59, 73, 122, 78, 45, 89, 6, 115, 70, 117, 17, 78, 58, 10, 85, 55, 4, 91, 40, 64, 113, 31, 102, 57, 87, 103, 16, 79, 126, 73, 124, 35, 80, 36, 16, 126, 26, 46, 92, 56, 69];
  let temp=34; 
  for(let i=0; i < crazy.length; i++){
   if ((crazy[i] ^ bytes[i]) !== temp){
     return failed; 
   } else {
     temp = bytes[i] ^ temp; 
   }
  }
  return "Correct flag!";
}
